import { render, staticRenderFns } from "./NoContentScreen.vue?vue&type=template&id=3a83d859&scoped=true&"
import script from "./NoContentScreen.vue?vue&type=script&lang=js&"
export * from "./NoContentScreen.vue?vue&type=script&lang=js&"
import style0 from "./NoContentScreen.vue?vue&type=style&index=0&id=3a83d859&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83d859",
  null
  
)

export default component.exports